module.exports = __webpack_public_path__ + "img/blueBoxBttomLeft.be5e64ee.svg";